import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Section } from '../../globalStyles';
import { Link } from 'react-router-dom';
import {
	FeatureText,
	FeatureTitle,
	FeatureWrapper,
	FeatureColumn,
	FeatureImageWrapper,
	FeatureName,
	FeatureTextWrapper,
	ReadMoreButton,
} from './FeaturesStyles';
import { featuresData } from '../../data/FeaturesData';

const Features = () => {
	const { t } = useTranslation();
	const initial = {
		y: 40,
		opacity: 0,
	};
	const animate = {
		y: 0,
		opacity: 1,
	};

	return (
		<Section smPadding="50px 10px" position="relative" inverse id="about">
			<Container>
						<FeatureTextWrapper>
							<FeatureTitle>{t("features_title")}</FeatureTitle>
						</FeatureTextWrapper>
				<FeatureWrapper>
					{featuresData.map((el, index) => (
						<Link 
							key={index}
							style={{
								textDecoration: "none",
								color: "black"
							}}
							to={el.link}
							onClick={() => {
								window.scrollTo({
									top: 0,
									behavior: "smooth"
								});
							}}
						>
							<FeatureColumn
								initial={initial}
								animate={animate}
								transition={{ duration: 0.5 + index * 0.1 }}
							>
								<FeatureImageWrapper className={el.imgClass}>
									<img src={el.image} alt={t(`features_data.${index}.name`)} />
								</FeatureImageWrapper>
								<FeatureName>{t(`features_data.${index}.name`)}</FeatureName>
								<FeatureText>{t(`features_data.${index}.description`)}</FeatureText>
								<ReadMoreButton>{t('read_more')}</ReadMoreButton>
							</FeatureColumn>
						</Link>
					))}
				</FeatureWrapper>
			</Container>
		</Section>
	);
};

export default Features;